import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import { GeckoAvatar, GeckoField, GECKO_CONSTS } from '../../ui';
import PropTypes from 'prop-types';
import './index.scss';
import classNames from 'classnames/bind';
import TeamOption from './teamOption';

const TableTeamSelect = (props) => {
  const { assignedTeamIds, onChange } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [newAssignedTeamIds, setNewAssignedTeamIds] = useState(assignedTeamIds);
  const teams = useSelector((state) => {
    return state.teams;
  });
  const geckoField = useRef(null);

  useEffect(() => {
    setNewAssignedTeamIds(assignedTeamIds);
  }, [assignedTeamIds]);

  const toggling = () => {
    setIsOpen(!isOpen);
    const element = ReactDOM.findDOMNode(geckoField.current);
    const fieldInput = element.querySelector('input');
    setTimeout(() => {
      fieldInput.focus();
    }, 100);
  };

  const renderOption = (option) => {
    if (option.team) {
      return <TeamOption {...option.team} />;
    }
    return option.label;
  };

  const handleChange = (_key, value) => {
    setNewAssignedTeamIds(value);
  };

  const onCloseDropDown = (event) => {
    event.stopPropagation();
    onChange(newAssignedTeamIds);
    setIsOpen(!isOpen);
  };

  const getFirstTeamName = () => {
    const firstTeam = teams.find((team) => team.id === assignedTeamIds[0]);
    if (!firstTeam) {
      return '';
    }
    return firstTeam.name;
  };

  const hasNoAssignedTeamIds = !assignedTeamIds || assignedTeamIds.length === 0;

  const getRemainingTeamNames = () => {
    const remainingTeams = assignedTeamIds
      .slice(1)
      .map((remainingTeam) => teams.find((team) => team.id === remainingTeam));
    return remainingTeams.map((remainingTeam) => remainingTeam.name).join(', ');
  };

  const hasAssignedTeamIdsMoreThan = (number) => {
    return assignedTeamIds && assignedTeamIds.length > number;
  };

  const renderAddButton = () => {
    if (hasNoAssignedTeamIds) {
      return (
        <button className={'table-team-select__add-button far fa-angle-down'} />
      );
    }
    return <button className={'table-team-select__add-button far fa-plus'} />;
  };

  const field = {
    key: 'value',
    type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    options: [
      {
        label: 'Teams',
        options: teams.map((team) => {
          return {
            team: team,
            label: team.name,
            value: team.id,
          };
        }),
      },
    ],
    optionRenderer: renderOption,
    valueRenderer: renderOption,
    config: props.selectProps || {},
    placeholder: 'Assign to a Team',
  };
  const values = { value: newAssignedTeamIds };
  return (
    <div
      className="table-team-select"
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div
        className={classNames('table-team-select__background', {
          'table-team-select__background--active': isOpen,
        })}
        onClick={onCloseDropDown}
      />

      <div>
        <div
          aria-label="Add team"
          className="table-team-select__avatar"
          onClick={toggling}
        >
          {hasNoAssignedTeamIds && <label>Assign to</label>}
          {hasAssignedTeamIdsMoreThan(0) && (
            <GeckoAvatar name={getFirstTeamName()} size={'sm'} />
          )}
          {hasAssignedTeamIdsMoreThan(1) && (
            <GeckoAvatar
              color={'#e0e1e1'}
              name={`+${assignedTeamIds.length - 1}`}
              showInitials={false}
              size={'sm'}
              title={getRemainingTeamNames()}
            />
          )}
          {renderAddButton()}
        </div>
      </div>
      <div
        className={classNames('table-team-select__dropdown', {
          'table-team-select__dropdown--active': isOpen,
        })}
      >
        <div className="table-team-select__dropdown__wrapper">
          <p>{props.answerName}</p>
          <GeckoField
            ref={geckoField}
            field={field}
            values={values}
            handler={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

TableTeamSelect.propTypes = {
  assignedTeamIds: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func,
  selectProps: PropTypes.object,
};

export default TableTeamSelect;
